import { Cloudinary, Transformation } from "@cloudinary/url-gen";
import { Position } from "@cloudinary/url-gen/qualifiers";
import { scale, fill } from "@cloudinary/url-gen/actions/resize";
import { source } from "@cloudinary/url-gen/actions/overlay";
import { image } from "@cloudinary/url-gen/qualifiers/source";
import { compass, focusOn } from "@cloudinary/url-gen/qualifiers/gravity";
import { solid } from "@cloudinary/url-gen/actions/border";
import { FocusOn } from "@cloudinary/url-gen/qualifiers/focusOn";

export function standardClipThumbnailImageUrl(
  _leftPersonImageId: string,
  _rightPersonImageId: string,
  _clipVisualizationImageId: string,
  borderColor = "blue"
): string {
  const cld = new Cloudinary({
    cloud: {
      cloudName: "dfno6k3qf",
    },
  });

  const leftPersonImageId = _leftPersonImageId.replace("/", ":");
  const rightPersonImageId = _rightPersonImageId.replace("/", ":");
  const clipVisualizationImageId = _clipVisualizationImageId.replace("/", ":");

  const personImagesWidth = 300;
  const personImagesHeight = 300;

  const totalWidth = personImagesWidth * 2;
  const totalHeight = personImagesHeight;

  const clipVisualizationImageWidthIncludingBorder = Math.floor(
    personImagesWidth * 0.75
  );
  const clipVisualizationImageHeightIncludingBorder =
    clipVisualizationImageWidthIncludingBorder;
  const clipVisualizationBorderWidth = 25;

  const constructedImage = cld.image("sample.jpg");

  constructedImage.resize(scale().width(totalWidth).height(totalHeight));
  constructedImage.overlay(
    source(
      image(leftPersonImageId).transformation(
        // resize to personImagesWidth x personImagesHeight, keeping the face in the center:
        new Transformation().resize(
          fill()
            .width(personImagesWidth)
            .height(personImagesHeight)
            .gravity(focusOn(FocusOn.face()))
        )
      )
    ).position(
      new Position()
        .gravity(compass("center"))
        .offsetX(-Math.floor(personImagesWidth / 2))
    )
  );

  constructedImage.overlay(
    source(
      image(rightPersonImageId).transformation(
        new Transformation().resize(
          fill()
            .width(personImagesWidth)
            .height(personImagesHeight)
            .gravity(focusOn(FocusOn.face()))
        )
      )
    ).position(
      new Position()
        .gravity(compass("center"))
        .offsetX(Math.floor(personImagesWidth / 2))
    )
  );

  constructedImage.overlay(
    source(
      image(clipVisualizationImageId).transformation(
        new Transformation()
          .border(solid(clipVisualizationBorderWidth, borderColor))
          .resize(
            scale()
              .width(clipVisualizationImageWidthIncludingBorder)
              .height(clipVisualizationImageHeightIncludingBorder)
          )
      )
    ).position(new Position().gravity(compass("center")))
  );

  return constructedImage.toURL();
}
